// extracted by mini-css-extract-plugin
module.exports = {"ghostbtn":"ghost-button-module--ghostbtn--2stey"};